<div class="registration-container">
  <div class="registration-content">
    <div class="registration-header">
      <h1>{{ titleText }}</h1>
    </div>

    <div *ngIf="!isStandalone && loadingPreview" class="loading-message">{{ previewCheckingText }}</div>
    <div *ngIf="acceptingAsLoggedInSupplier" class="loading-message">{{ acceptingInviteText }}</div>

    <div *ngIf="!isStandalone && !loadingPreview && !acceptingAsLoggedInSupplier && previewError" class="error-message">
      <p>{{ previewError }}</p>
    </div>

    <ng-container *ngIf="!acceptingAsLoggedInSupplier && (isStandalone || (!loadingPreview && preview?.valid))">
      <p class="invite-hint standalone-hint" *ngIf="isStandalone">
        {{ standaloneHintText }}
      </p>

      <div class="invite-summary" *ngIf="!isStandalone">
        <p *ngIf="preview?.calculationTitle"><strong>{{ preview?.calculationTitle }}</strong></p>
        <p class="invite-route">
          {{ preview?.fromCountryName || '—' }}<span *ngIf="preview?.fromCity">, {{ preview?.fromCity }}</span>
          →
          {{ preview?.toCountryName || '—' }}<span *ngIf="preview?.toCity">, {{ preview?.toCity }}</span>
        </p>
        <p class="invite-hint">{{ inviteHintText }}</p>
      </div>

      <div *ngIf="error" class="error-message">
        <p>{{ error }}</p>
      </div>

      <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
        <div class="form-section">
          <h3>{{ personalInfoText }}</h3>

          <div class="form-group">
            <label for="email">{{ emailText }} <span class="required">{{ requiredText }}</span></label>
            <input type="email" id="email" formControlName="email"
                   [class.error]="registrationForm.get('email')?.invalid && registrationForm.get('email')?.touched"
                   placeholder="example@mail.com" />
            <span class="error-text" *ngIf="getFieldError('email')">{{ getFieldError('email') }}</span>
          </div>

          <div class="form-group">
            <label for="fullName">{{ fullNameText }} <span class="required">{{ requiredText }}</span></label>
            <input type="text" id="fullName" formControlName="fullName"
                   [class.error]="registrationForm.get('fullName')?.invalid && registrationForm.get('fullName')?.touched"
                   [placeholder]="fullNamePlaceholderText" />
            <span class="error-text" *ngIf="getFieldError('fullName')">{{ getFieldError('fullName') }}</span>
          </div>

          <div class="form-group">
            <label for="phone">{{ phoneText }}</label>
            <input type="tel" id="phone" formControlName="phone" placeholder="+7 700 123 4567" />
          </div>
        </div>

        <div class="form-section">
          <h3>{{ passwordSectionText }}</h3>

          <div class="form-group">
            <label for="password">{{ passwordText }} <span class="required">{{ requiredText }}</span></label>
            <input type="password" id="password" formControlName="password"
                   [class.error]="registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched"
                   [placeholder]="passwordPlaceholderText" />
            <span class="error-text" *ngIf="getFieldError('password')">{{ getFieldError('password') }}</span>
          </div>

          <div class="form-group">
            <label for="confirmPassword">{{ confirmPasswordText }} <span class="required">{{ requiredText }}</span></label>
            <input type="password" id="confirmPassword" formControlName="confirmPassword"
                   [class.error]="registrationForm.get('confirmPassword')?.invalid && registrationForm.get('confirmPassword')?.touched"
                   [placeholder]="confirmPasswordPlaceholderText" />
            <span class="error-text" *ngIf="getFieldError('confirmPassword')">{{ getFieldError('confirmPassword') }}</span>
          </div>
        </div>

        <div class="form-section">
          <h3>{{ companySectionText }}</h3>

          <div class="form-group">
            <label for="companyName">{{ companyNameText }} <span class="required">{{ requiredText }}</span></label>
            <input type="text" id="companyName" formControlName="companyName"
                   [class.error]="registrationForm.get('companyName')?.invalid && registrationForm.get('companyName')?.touched"
                   [placeholder]="companyNamePlaceholderText" />
            <span class="error-text" *ngIf="getFieldError('companyName')">{{ getFieldError('companyName') }}</span>
          </div>

          <div class="form-group">
            <label for="countryId">{{ countryText }} <span class="required">{{ requiredText }}</span></label>
            <app-country-select formControlName="countryId" [countries]="countries" [placeholder]="selectCountryText"
                    [class.error]="registrationForm.get('countryId')?.invalid && registrationForm.get('countryId')?.touched"></app-country-select>
            <span class="error-text" *ngIf="getFieldError('countryId')">{{ getFieldError('countryId') }}</span>
          </div>
        </div>

        <app-legal-consent class="form-consent" [control]="registrationForm.get('acceptTerms')"></app-legal-consent>
        <app-legal-consent class="form-consent" mode="personal-data" [control]="registrationForm.get('acceptPersonalData')"></app-legal-consent>


        <div class="form-actions">
          <button type="submit" class="submit-button" [disabled]="submitting || registrationForm.invalid">
            <span *ngIf="!submitting">{{ submitText }}</span>
            <span *ngIf="submitting">{{ submittingText }}</span>
          </button>

          <a *ngIf="isStandalone" routerLink="/login" class="login-link">{{ hasAccountText }}</a>
          <button *ngIf="!isStandalone" type="button" class="login-link-button" (click)="goToLoginWithExistingAccount()">
            {{ alreadyHaveAccountButtonText }}
          </button>
        </div>
      </form>
    </ng-container>
  </div>
</div>
